import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const useLoadTitle = () => {
  const location = useLocation();

  const title = useMemo(() => {
    const path = location.pathname.replaceAll("/", " ");
    let name = path?.replaceAll("-", " ");
    name = name?.replaceAll("realestates project create", "Creación de proyecto");
    name = name?.replaceAll("realestates create", "Creación de propiedad");
    name = name?.replaceAll("realestates", "Propiedades");
    name = name?.replaceAll("users", "Usuarios");
    name = name?.replaceAll("user", "Usuarios");
    name = name?.replaceAll("owners", "Propietarios");
    name = name?.replaceAll("agencies", "Agencias");
    name = name?.replaceAll("profile", "Perfil");
    name = name?.replaceAll("tools", "Herramientas");
    name = name?.replaceAll("app movil", "App móvil");
    name = name?.replaceAll("mortgage reference", "Referimiento hipotecario");
    name = name?.replaceAll("logout", "Cerrar Sesión");
    name = name?.replaceAll("login", "Iniciar Sesión");
    name = name?.replaceAll("register", "Registrarse");
    name = name?.replaceAll("detail", "Detalle");
    name = name?.replaceAll("editar", "Edición");
    name = name?.replaceAll("edit", "Edición");
    name = name?.replaceAll("create", "Creación");
    name = name?.replaceAll("list", "Listado");
    name = name?.replaceAll("filters", "Filtros");
    name = name?.replaceAll("search", "Buscar");
    name = name?.replaceAll("reports", "Reportes");
    name = name?.replaceAll("sales", "Ventas");
    name = name?.replaceAll("monthly", "Informe de cierre de inventario mensual");
    name = name?.replaceAll(
      "monthly report",
      "Informe de cierre de inventario mensual"
    );
    name = name?.replaceAll("property report", "Informe de propiedad");
    name = name?.replaceAll("users report", "Informe de usuarios");
    name = name?.replaceAll("agencies report", "Informe de agencias");
    name = name?.replaceAll("clients report", "Informe de clientes");
    name = name?.replaceAll("commission report", "Informe de comisiones");

    return name;
  }, [location]);

  useEffect(() => {
    document.title = title || "MAXCORE";
  }, [title]);
};

export default useLoadTitle;
